import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import ImagePlaceholder from "assets/images/imageplaceholder.png"

import "react-lazy-load-image-component/src/effects/blur.css"

const LazyLoadWrapper = ({
  className,
  onError,
  src,
  effect,
  height,
  width,
}) => {
  if (src && src === "undefined") {
    src = undefined
  }

  return (
    <LazyLoadImage
      className={className}
      onError={onError}
      alt=" "
      src={src || ImagePlaceholder}
      placeholderSrc={ImagePlaceholder}
      effect={effect}
      height={height}
      width={width}
    />
  )
}
export default LazyLoadWrapper
